import { UserType } from '../entities/tenant/user.type';
import { Entity } from '../entities/entity';
import * as Enumerable from 'linq';

export enum SecurityRoleType {
    EmployeeOwner = 'Owner',
    EmployeeAdministrator = 'Administrator',
    EmployeeTechnician = 'Technician',
    EmployeeOperations = 'Operations',
    EmployeeScheduler = 'Scheduler',
    EmployeeFinance = 'Finance',
    EmployeeCompliance = 'Compliance',
    SubcontractorAdministrator = 'Subcontractor Administrator',
    SubcontractorUser = 'Subcontractor User',
    SystemAdministrator = 'System Administrator',
    ClientUser = 'Client User',
    None = 'None',
}

export const SYSTEM_ADMINISTRATOR_ROLE_ID = '078f8eee-1a17-4bc6-a6a9-c1f3682f6b08';

// System Administrator is a WorkBuddy-internal role seeded directly in the database.
// It must never be assignable via any API path (UI, Postman, SCIM, bulk import, etc.)
// — not even by callers who already hold System Administrator.
export function isSystemAdministratorRole(role?: { _id?: string; name?: string }): boolean {

    if (!role) return false;

    return role._id === SYSTEM_ADMINISTRATOR_ROLE_ID
        || role.name === SecurityRoleType.SystemAdministrator;
}


export interface SecurityRole {
    _id: string;
    name: string;
    hidden?: boolean;
    type: UserType;
    system: boolean;
    description: string;
    rights: number[];
    inUse?: boolean;
}

export interface SecurityRoleTiny {
    _id?: string;
    name: string;
    type: UserType;
    rights: number[];
}

export interface RoleEntity extends Entity {
    type: UserType;
}

export class LoginContactSecurityRoleTiny implements SecurityRoleTiny {

    // public static id = '00000000-0000-0000-0000-000000000001';

    // public readonly _id = LoginContactSecurityRoleTiny.id;
    public readonly rights: number[];
    public type = UserType.LoginContact;
    // public readonly isClient: boolean;
    // public readonly isSubContractor: boolean;
    public readonly name = 'Login Contact Combined Role';


    constructor(roles: SecurityRoleTiny[]) {
        this.rights = Enumerable.from(roles).selectMany(x => x.rights).toArray();
        // this.isClient = Enumerable.from(roles).any(x => x.type === UserType.Client);
        // this.isSubContractor = Enumerable.from(roles).any(x => x.type === UserType.Subcontractor);
    }
}
